<template>
  <div class="titleTexts">
    <div class="title_1">
      <van-row type="flex" justify="end">
        <switch-lang color="#377ED7" />
      </van-row>
      <div class="ss_title">
        {{ $t("curriculum.curriculum_desc") }}
      </div>
      <!-- <div class="question pb-10" @click="show = true"><van-icon name="question-o" /> {{ $t('ss_online.support_home')
        }}
      </div> -->
    </div>
    <div class="list">
      <div class="title">{{ $t("ss_online.Resources") }}</div>
      <div>
        <div>
          <div class="itemText" :class="yuyue ? 'active' : ''" @click="ixlShow(yuyue, 'yuyue')">
            <div class="flex1">{{ $t("curriculum.yuyue") }}</div>
            <van-icon name="arrow-down" v-if="!yuyue" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="yuyue">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">
              {{ $t("curriculum.yuyue_desc") }}
            </div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lgBSKgMN525Ymhg5UE40tc88A-cz.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lgBSKgMN525Ymhg5UE40tc88A-cz.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lgBSKgMN525Ymhg5UE40tc88A-cz.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="leap ? 'active' : ''" @click="ixlShow(leap, 'leap')">
            <div class="flex1">{{ $t("curriculum.leap") }}</div>
            <van-icon name="arrow-down" v-if="!leap" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="leap">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.leap_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8039384lmGsvG3W1V45UzJ-Gwn08vamNQtW.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8039384lmGsvG3W1V45UzJ-Gwn08vamNQtW.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8039384lmGsvG3W1V45UzJ-Gwn08vamNQtW.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="ufli ? 'active' : ''" @click="ixlShow(ufli, 'ufli')">
            <div class="flex1">{{ $t("curriculum.ufli") }}</div>
            <van-icon name="arrow-down" v-if="!ufli" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="ufli">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.ufli_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lje7hN6Yo0fojLkaI-jam8gsRYar.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lje7hN6Yo0fojLkaI-jam8gsRYar.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lje7hN6Yo0fojLkaI-jam8gsRYar.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="mapGrowth ? 'active' : ''" @click="ixlShow(mapGrowth, 'mapGrowth')">
            <div class="flex1">{{ $t("curriculum.map_growth") }}</div>
            <van-icon name="arrow-down" v-if="!mapGrowth" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="mapGrowth">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.map_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lrWet69XJIkUx_9gLf9-diyhACM-.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lrWet69XJIkUx_9gLf9-diyhACM-.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lrWet69XJIkUx_9gLf9-diyhACM-.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="ibPyp ? 'active' : ''" @click="ixlShow(ibPyp, 'ibPyp')">
            <div class="flex1">{{ $t("curriculum.ib_pyp") }}</div>
            <van-icon name="arrow-down" v-if="!ibPyp" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="ibPyp">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.ib_pyp_desc") }}</div>

            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020804ll-M2WIa2Yk0mg0wAz_oob9RgguA.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020804ll-M2WIa2Yk0mg0wAz_oob9RgguA.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020804ll-M2WIa2Yk0mg0wAz_oob9RgguA.mp4" width="100%" controls></video>
              </div>
            </div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020804lg7BI64I9reD2gFG_IHbiGUYYBo9.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020804lg7BI64I9reD2gFG_IHbiGUYYBo9.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020804lg7BI64I9reD2gFG_IHbiGUYYBo9.mp4" width="100%" controls></video>
              </div>
            </div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020804luavHf_92c20RFnxSe1OeCnRP9Jv.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020804luavHf_92c20RFnxSe1OeCnRP9Jv.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020804luavHf_92c20RFnxSe1OeCnRP9Jv.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="enrichment ? 'active' : ''" @click="ixlShow(enrichment, 'enrichment')">
            <div class="flex1">{{ $t("curriculum.enrichment") }}</div>
            <van-icon name="arrow-down" v-if="!enrichment" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="enrichment">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.enrichment_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lr9DCQ8OXMKvZfpXcVkLxpx_AYFE.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lr9DCQ8OXMKvZfpXcVkLxpx_AYFE.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lr9DCQ8OXMKvZfpXcVkLxpx_AYFE.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="englishEnrichment ? 'active' : ''" @click="ixlShow(englishEnrichment, 'englishEnrichment')">
            <div class="flex1">{{ $t("curriculum.english_enrichment") }}</div>
            <van-icon name="arrow-down" v-if="!englishEnrichment" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="englishEnrichment">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.english_enrichment_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lt2qbhcTX9nUcmSLaBmJTJKrotZR.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lt2qbhcTX9nUcmSLaBmJTJKrotZR.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020803lt2qbhcTX9nUcmSLaBmJTJKrotZR.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="mathEnrichment ? 'active' : ''" @click="ixlShow(mathEnrichment, 'mathEnrichment')">
            <div class="flex1">{{ $t("curriculum.math_enrichment") }}</div>
            <van-icon name="arrow-down" v-if="!mathEnrichment" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="mathEnrichment">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.math_enrichment_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8020828ltu8QHBFag_N6YSTqaVqcxYeZ2Vk.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8020828ltu8QHBFag_N6YSTqaVqcxYeZ2Vk.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8020828ltu8QHBFag_N6YSTqaVqcxYeZ2Vk.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="chineseEnrichment ? 'active' : ''" @click="ixlShow(chineseEnrichment, 'chineseEnrichment')">
            <div class="flex1">{{ $t("curriculum.chinese_enrichment") }}</div>
            <van-icon name="arrow-down" v-if="!chineseEnrichment" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="chineseEnrichment">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.chinese_enrichment_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lueMHRLqGiyO7l9Wm4g61dRLdMWE.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lueMHRLqGiyO7l9Wm4g61dRLdMWE.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8025124lueMHRLqGiyO7l9Wm4g61dRLdMWE.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemText" :class="studentSupport ? 'active' : ''" @click="ixlShow(studentSupport, 'studentSupport')">
            <div class="flex1">{{ $t("curriculum.student_support") }}</div>
            <van-icon name="arrow-down" v-if="!studentSupport" />
            <van-icon name="arrow-up" v-else />
          </div>
          <div class="activeText" v-if="studentSupport">
            <div class="common">
              {{ $t("ss_online.What_is") }}
            </div>
            <div class="introduce">{{ $t("curriculum.student_support_desc") }}</div>
            <div class="video" href="">
              <a class="pdf_url" href="https://m2.files.ivykids.cn/cloud01-file-converted-8027753llBPFwAkwxsEZrZ36KXccD7MOUpq.mp4">
                <img src="@/assets/icon.png" alt="Logo" class="url" />
                <span class="text">{{ $t("curriculum.Video") }}</span>
              </a>
              <div class="video_url">
                <video poster="https://m2.files.ivykids.cn/cloud01-file-converted-8027753llBPFwAkwxsEZrZ36KXccD7MOUpq.mp4?vframe/jpg/offset/1" src="https://m2.files.ivykids.cn/cloud01-file-converted-8027753llBPFwAkwxsEZrZ36KXccD7MOUpq.mp4" width="100%" controls></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom-tools">
      <span class="iconfont iconfont-download"></span>
      <a href="https://m2.files.ivykids.cn/cloud01-file-8025768FjNPDw-q7fZRTyXj4kimthYS3ka0.pdf">{{ $t("ss_online.download_pdf") }}</a>
    </div> -->
    <van-action-sheet v-model="show" :title="$t('ss_online.support_home')">
      <div class="content_home color6 font14">
        <div>{{ $t("ss_online.work_with") }}</div>
        <div class="pt-10">{{ $t("ss_online.make_a") }}</div>
        <div class="pt-10">{{ $t("ss_online.provide_support") }}</div>
        <div class="pt-10 mb-20">{{ $t("ss_online.monitor") }}</div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from "vue";
import { ActionSheet, Toast, Icon, Tag } from "vant";
import SwitchLang from "@/components/SwitchLang";

Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Tag);

export default {
  name: "JournalContent",
  components: {
    "switch-lang": SwitchLang,
  },
  data() {
    return {
      show: false,
      yuyue: false,
      leap: false,
      ufli: false,
      mapGrowth: false,
      ibPyp: false,
      enrichment: false,
      englishEnrichment: false,
      mathEnrichment: false,
      chineseEnrichment: false,
      studentSupport: false,
    };
  },
  mounted() {
      window.scrollTo(0, 0);
    },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#fff");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    ixlShow(type, name) {
      console.log(type);
      this[name] = !type;
    },
    copyText(text) {
      this.$copyText(text).then(() => {
        Toast(this.$t("student.copy_success"));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.titleTexts {
  .title_1 {
    padding: 12px 16px;
    font-size: 13px;
    color: #333333;
    background: #fff;

    .ss_title {
      margin-top: 12px;
    }

    .log_in {
      font-weight: bold;
      margin-top: 12px;
    }

    .question {
      color: #4d88d2;
      margin-top: 12px;
      font-size: 14px;
    }
  }

  .list {
    padding: 12px 16px 30px 16px;
    font-size: 13px;
    background: #fff;
    border-top: 12px solid #f7f8fa;

    .title {
      font-size: 13px;
      color: #666666;
      padding-top: 12px;
      padding-bottom: 4px;
    }

    .itemText {
      display: flex;
      padding: 14px 16px;
      border-radius: 8px;
      border: 1px solid #dcdee0;
      margin-top: 12px;
      align-items: center;

      .flex1 {
        flex: 1;
        font-size: 15px;
      }

      i {
        font-size: 14px;
      }
    }

    .active {
      background: #4d88d2;
      color: #fff;
      border-radius: 8px 8px 0px 0px;
      border: 1px solid #4d88d2;
    }

    .activeText {
      border: 1px solid #dcdee0;
      border-top: none;
      padding: 0 16px 16px;
      border-radius: 0px 0px 8px 8px;

      .common {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
        padding-top: 20px;
      }

      .introduce {
        font-size: 13px;
        color: #333333;
        margin-top: 12px;
      }

      .pdf_url {
        padding: 12px;
        background: #f7f8fa;
        border-radius: 6px;
        display: flex;
        align-items: center;
        margin-top: 12px;

        .text {
          flex: 1;
          font-size: 14px;
          color: #333333;
          margin-left: 8px;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }

      .video {
        background: #f7f8fa;

        .video_url {
          padding: 4px 16px 16px;
        }
      }

      .qr-section {
        display: flex;
        justify-content: center;
        padding: 20px 0;

        .qr-img {
          width: 200px;
          height: 200px;
          object-fit: contain;
        }
      }
    }
  }

  .orange {
    color: #f5a429;
  }

  .content_home {
    padding: 16px;
  }

  .bottom-tools {
    text-align: center;
    background-color: #fff;
    padding-bottom: 24px;
    font-size: 15px;
    font-weight: 400;
    color: #4d88d2;

    a {
      margin-left: 3px;
      color: #4d88d2 !important;
    }
  }
}
</style>
